import { CommonModule } from '@angular/common';
import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { IonAccordion, IonItem, IonLabel } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyResultComponent, SkeletonCardGenericComponent } from '@okcargo-apps/layout-ionic';
import { CompanyService } from '../../company/company.service';
import { NoticeDocumentationCardComponent } from '../notice-documentation-card/notice-documentation-card.component';

@Component({
  selector: 'lib-notice-documentation-list',
  templateUrl: './notice-documentation-list.component.html',
  styleUrls: ['./notice-documentation-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    TranslateModule,
    IonLabel,
    IonItem,
    IonAccordion,
    NoticeDocumentationCardComponent,
    SkeletonCardGenericComponent,
    EmptyResultComponent,
  ],
})
export class NoticeDocumentationListComponent {
  private readonly companyService = inject(CompanyService);

  public readonly expiredCompanyDocuments = this.companyService.expiredOrNotUploadedDocuments;
  public readonly loading = computed(() => this.companyService.companyDocumentsLoading());
}
